import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useImpersonation } from '../../hooks/useImpersonation';
import { Button } from '../ui/button';
import { UserX, Loader2 } from 'lucide-react';

export function ImpersonationBanner() {
  const { t } = useTranslation();
  const { isImpersonating, impersonatingUser, stopImpersonating } = useImpersonation();
  const [isStopping, setIsStopping] = useState(false);

  if (!isImpersonating) return null;

  const name = impersonatingUser
    ? `${impersonatingUser.first_name} ${impersonatingUser.last_name}`.trim() || impersonatingUser.username
    : '…';

  const handleStop = async () => {
    setIsStopping(true);
    await stopImpersonating();
  };

  return (
    <div className="bg-amber-400 dark:bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-between text-sm font-medium z-50 relative">
      <div className="flex items-center gap-2">
        <UserX className="h-4 w-4 shrink-0" />
        <span>
          {t('impersonation.banner', { name })}
          {' — '}
          <span className="font-normal">{t('impersonation.readOnly')}</span>
        </span>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={handleStop}
        disabled={isStopping}
        className="border-amber-700 bg-transparent text-amber-950 hover:bg-amber-500 dark:hover:bg-amber-600 h-7 ml-4 shrink-0"
      >
        {isStopping ? (
          <Loader2 className="h-3 w-3 animate-spin" />
        ) : (
          t('impersonation.stop')
        )}
      </Button>
    </div>
  );
}
